export default __webpack_public_path__ + "static/LeituraSansTwo-Black-19117930a3ac2cacb1c12f29feaca971.woff";